export function getStreamingServiceLogoPath(serviceId: string): string {
  const logoId = serviceId === "canalvod" ? "canal" : serviceId;
  return `/assets/images/icons/${logoId}.svg`;
}
